<div [formGroup]="requestResetForm" class="password-reset-request-form">

  <div class="password-reset-request-form__header">
    <div i18n="@@shared.password-reset-request-form.title">Reset Password</div>
    <mat-icon class="logo" svgIcon="logo"></mat-icon>
  </div>

  <div class="password-reset-request-form__body">

    <tm-error-message [message]="(errorMessage$ | async) ?? ''" />

    @if (infoMessage$ | async; as infoMessage) {
      <tm-info-message [message]="infoMessage"/>
    }

    <div class="form-field">
      <label for="login_email" i18n="@@shared.password-reset-request-form.email">Email</label>
      <input (keyup.enter)="requestReset()"
             [tmAutoFocus]="true"
             formControlName="email"
             id="login_email"
             name="email"
             type="email"/>
    </div>

    <div class="buttons">
      <button (click)="requestReset()"
              [disabled]="requestResetForm.invalid"
              color="primary"
              mat-flat-button
              name="login">
        @if (processing$ | async) {
          <mat-spinner color="primary" diameter="20" mode="indeterminate"></mat-spinner>
        } @else {
          <span i18n="@@shared.password-reset-request-form.submit">Request password reset</span>
        }
      </button>
    </div>

    <div class="login-link">
      <a i18n="@@core.password-reset-form.return" routerLink="/login" (click)="returnToLogin($event)">Return to Login</a>
    </div>

  </div>
</div>
